import {
    Button,
    Checkbox,
    Dialog,
    FormControl,
    FormControlLabel,
    FormHelperText,
    MenuItem,
    Select,
    SwipeableDrawer,
    TextField,
} from '@material-ui/core';
import {
    sendPhoneOTP,
    sendMobileOTP,
    sendEmailOTP,
    getAmcList,
} from '../../../../redux-store/actions/nct';
import { PurchaseInputField, UI_KEYS, API_KEYS, getSipDays, consolidateErrors } from './mf-helpers';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import en from '../../../../lang/en-us';
import { CustomRadio } from '../../../../lib/CustomRadio';
import SegmentedControl from '../../../common/segmented-control';
import {
    getInvestorLatestDetails,
    getFundTransactionInfo,
} from '../../../../redux-store/actions/commercialTransactions';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
    ChequeFile,
    initialSchemeInfo,
    InitStateForPurchaseType,
    PennyDropStatus,
} from '../../../../redux-store/reducers/newPurchase';
import { RootStateType } from '../../../../redux-store/reducers';
import {
    checkFatca,
    createProspectFolio,
    makeAdditionalPurchase,
    makeNewPurchase,
    performPennyDropValidation,
    validateArn,
} from '../../../../redux-store/actions/newPurchase';
import {
    SET_SCHEME_INFO,
    SET_FOLIO_PURCHASE_TYPE,
    CLEAR_SCHEME_INFO,
    SET_SIP_OR_LUMPSUM,
    CLEAR_SIP_OR_LUMPSUM,
} from '../../../../redux-store/types/newPurchase';
import { getCountries } from '../../../../redux-store/actions/link';
import { getCountryNameFromCode } from '../ProfileDetails/FatcaDetailsPurchase';
import { schemeType } from '../../../../redux-store/types/newPurchase';
import DatePickerInput from '../../../../lib/DatePicker';
import useSip, { freqType } from '../../../../hooks/useSip';
import { CheckBoxField } from '../../../../lib/CheckBoxField';
import { favLogos } from '../../../../logo/logos';
import {
    ArnPayloadType,
    ErrorSectionTypes,
    explorePath,
    ExplorePaths,
    FatcaDetails,
    folioPurchaseEnum,
    NewPurchasePayload,
    Nominee,
    OTMVerifyStatus,
    PaymentTypes,
    ReInvestTypes,
} from './types';
import {
    AccountTypes,
    IsAllow,
    PlanTypes,
    SCHEMES_RESPONSE,
} from '../../../../redux-store/types/portfolio';
import { CommercialRootPath } from '../routeConfig';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import {
    AdditionalPurchaseValidations,
    NewPurchaseValidations,
    shouldUploadChequeButDidNot,
    showHintTemplateForMaxAndMin,
} from './Validations';
import {
    DEFAULT_MAX_INVESTMENT,
    DEFAULT_MIN_TAT,
    getDateString,
    getKfinFormatDate,
    ifscRegex,
    isMobileDevice,
    NEW_PURCHASE,
    OTM_MAX_DATE,
    OTP_ACTIONS,
    REDEMPTION,
} from '../../../../utils/constants';
import { InvestThrough } from '../Switch/types';
import { getNewSchemeDetail } from '../../../../redux-store/actions/commercialTransactions';
import {
    calculateInstallment,
    endDateDisable,
    formatRtaResponse,
    formatWeekdayDisplay,
    getAllowedSipMonthDays,
    getAllowedSipWeekdays,
    getWeekdayDropdownOptions,
    getFoliosFromAmc,
    getValueForNewPurchase,
    handleCalendarView,
    isFatcaVerified,
    isFolioNew,
    isMotilalSipEndDateDisabled,
    isMotilalSipStartDateDisabled,
    isSipAllowed,
    isWeekdayNamedArray,
    MAX_DATE,
    portfolioHasIsin,
    sortSip,
    startDateDisable,
    TRXN_TYPE_MAP,
} from '../utils';
import { isMotilalWeekly, MOTILAL_WEEKLY_DAYS } from '../../../../hooks/motilalSipHelpers';
import { SelectBank } from '../Redemption/SelectBank';
import {
    AmountType,
    schemeDetailsNewType,
    sipType,
} from '../../../../redux-store/types/commercialTransactions';
import IdcwOptions, { idcwDetailsType } from '../IdcwOptions';
import { bankDetailsInitState, BankDetailsType } from '../../../../hooks/useBank';
import { KYCCheck } from '../../../common/KYCCheck';
import { GET_INVESTOR_LATEST_DETAILS } from '../../../../redux-store/types/commercialTransactions';
import InvestThroughPage, { useInvestThrough } from '../InvestThrough';
import AsyncLoader from '../../../../lib/AsyncLoader';
import { Skeleton } from '@material-ui/lab';
import { apDividendFilters } from '../AdditionalPurchase/types';
import FatcaCheck from '../../../common/FatcaCheck';
import { RegisterWith, SET_IS_FROM_PRE_LOGIN } from '../../../../redux-store/types/login';
import { FaqLink } from '..';
import OTMCheck from './OTMCheck';
import { IFSCError } from '../IFSCError';
import { RtaSchemeLoadingDialog } from '../AdditionalPurchase/ap-invest';
import { PurchaseTypes } from '../../trackStatus/types';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';
import { isWeekend } from 'date-fns';
import { rtaNames } from '../../../common/FatcaCheck.types';
import { NRI_CODES, portfoliosByPurchaseAllow } from '../../portfolios/utils';
import { getPinCode } from '../../makeNct/UpdateNominee/types';
import NavDialog from './nav-dialog';
import { NomineePopup } from '../../NomineePopup';

const { dbCommercial, dashboard, common } = en;

const SEGMENTS = [PaymentTypes.Lumpsum, PaymentTypes.SIP];

export const TabElementSkeleton = ({ width = 125, height = 25 }): JSX.Element => {
    const _width = width > 300 ? 300 : width;
    return (
        <div style={{ paddingRight: 10 }}>
            <Skeleton animation="wave" height={height} width={_width} variant="text" />
        </div>
    );
};

export const TabElementSkeletonRect = ({ width = 125, height = 25 }): JSX.Element => {
    const _width = width > 300 ? 300 : width;
    return (
        <div style={{ paddingRight: 10, paddingBottom: 10 }}>
            <Skeleton animation="wave" height={height} width={_width} variant="rect" />
        </div>
    );
};

const EMPTY_SIP_DATES: Array<string | number> = [];

function MfInvestment(props: any) {
    const { data = null } = props?.portfolios || {};
    const { pan, newToMF } = props;
    const { isin } = props.match.params || {};
    const { type } = props.location.state || {};
    const {
        purchaseDetails = {},
        schemeInfo = {} as any,
        folioPurchaseType = '',
        fatcaStatusData = [],
        investorName,
        investorEmail,
        investorMobile,
        apiPendingActions,
        sipOrLumpsum,
    }: InitStateForPurchaseType & {
        investorName: string;
        investorEmail: string;
        investorMobile: string;
    } = useSelector(({ newPurchase, authReducer }: RootStateType) => {
        return {
            ...newPurchase,
            investorName: authReducer.displayName,
            investorEmail: authReducer.email,
            investorMobile: authReducer.mobile,
        };
    });
    const dispatch = useDispatch();

    const fatcaDetails: FatcaDetails[] = purchaseDetails.fatcaDetails;
    const nomineeFlag = purchaseDetails.nomineeFlag;
    const factaDetailsByHolder = fatcaDetails.find((fatca) => fatca.fatcaId === 'FH');
    //ui-state
    const [folios, setFolios] = useState<Array<string>>([]);
    const [filterFolioSchemes, setFilterFolioSchemes] = useState<SCHEMES_RESPONSE[]>([]);
    const [sipDay, setSipDay] = useState<number>();
    const [selectedWeekday, setSelectedWeekday] = useState<string | null>(null);
    const [currentScheme, setScheme] = useState<schemeType>(schemeInfo);
    const [currentFolio, setCurrentFolio] = useState<string>(schemeInfo.folio);
    const [addPurchaseDetails, setAddPurchaseDetails] = useState<AmountType | null>(null);
    const [sipDetails, setSipDetails] = useState<sipType | null>(null);
    const [newPurchaseDetails, setNewPurchaseDetails] = useState<AmountType | null>(null);
    const [commonDetails, setCommonDetails] = useState<schemeDetailsNewType[0] | null>(null);
    const [subPlans, setSubPlans] = useState<any | null>(null);
    const [idcwDetails, setIdcwDetails] = useState<idcwDetailsType | null>(null);
    const [purchaseType, setPurchaseType] = useState(sipOrLumpsum || type || SEGMENTS[0]);
    const [loading, setLoading] = useState<number>(0);
    const [ifscError, setIfscError] = useState(false);
    const [activeHandle, setActiveHandle] = useState<boolean>(false);
    const [touched, setTouched] = useState<any>({});

    const [amcList, setamcList] = useState<any>({});
    const [accCode, setaccCode] = useState<string>('');

    const [termsAccept, setTermsAccept] = useState<{ checked: boolean; message?: string }>({
        checked: false,
    });
    const [showFatcaDialog, setShowFatcaDialog] = useState(false);
    const [showNavDialog, setShowNavDialog] = useState(false);
    const [otmVerifyStatus, setOtmVerifyStatus] = useState<OTMVerifyStatus>(
        OTMVerifyStatus.NOT_SET,
    );
    const [show, setShow] = useState<boolean>(false);
    const [euin, setEuin] = useState<boolean>(false);
    const [latestDataCalled, setLatestDataCalled] = useState<any>(null);
    const [rtaSchemeCalled, setRtaSchemeCalled] = useState(false);
    const [schemeAMC, setSchemeAMC] = useState<string>('');
    const [kfinFlag, setkfinFlag] = useState(false);
    const [kfinFlagSet, setkfinFlagSet] = useState(false);

    const { formik } = useInvestThrough((currentScheme as any).investMode);

    const amcCode =
        new URLSearchParams(props.location.search).get('amc') || props.newSchemeDetails?.amc || '';

    // console.log('amcCode = ',amcCode)
    const handleSegmentChange = (selectedSegmentIndex: number) => {
        setPurchaseType(SEGMENTS[selectedSegmentIndex]);
        setTouched((prev: any) => ({ ...prev, amount: false }));
        setErrors((prev: any) => ({ ...prev, [API_KEYS.AMOUNT]: true }));
        setScheme((prev: any) => ({ ...prev, sipType: purchaseType, amount: 0 }));
    };
    const [errors, setErrors] = useState<any>({});
    // Sip flows
    const [perpetual, setPerpetual] = useState<boolean>(false);
    const [currentInstallment, setInstallment] = useState<any>(
        !!sipDetails && currentScheme?.frequency
            ? sipDetails[currentScheme?.frequency as string]?.minimumInstallments[0].minAmount
            : 1,
    );
    const sipDates =
         sipDetails && currentScheme.frequency
             ? sipDetails[currentScheme.frequency]?.dates ?? EMPTY_SIP_DATES
             : EMPTY_SIP_DATES;
    const [startDate, endDate, setStartDate, setEndDate, resetEndDate, installment_diff] = useSip({
        frequencyType: currentScheme.frequency || 'Monthly',
        numInstallments: currentInstallment,
        kfinFlag,
        sipDay: sipDay?.toString() || new Date().getDate().toString(),
        sipDates,
        sipTat:
            !!sipDetails && !!Number(sipDetails[currentScheme?.frequency as string]?.minSipTat)
                ? Number(sipDetails[currentScheme.frequency as string]?.minSipTat)
                : DEFAULT_MIN_TAT,
        setErrors,
        perpetual,
        amc: commonDetails?.amc,
        applyMotilalRules: true,
        allowedSipWeekdays: selectedWeekday
            ? getAllowedSipWeekdays([selectedWeekday])
            : getAllowedSipWeekdays(
                  sipDetails?.[currentScheme?.frequency as string]?.dates || [],
              ),
        allowedSipMonthDays: getAllowedSipMonthDays(
            sipDetails?.[currentScheme?.frequency as string]?.dates || [],
        ),
    });
    const clearData = useRef(true);
    const [installmentIndex, setInstallmentIndex] = useState<number>(0);
    useEffect(() => {
        async function getInvestorDetails() {
            try {
                const res = await props.getInvestorLatestDetails();
                const bankAccountType = res[0]?.bank[0]?.accountType;
                const taxStatusCode = res[0]?.taxStatus;
                const isNRI = NRI_CODES.includes(taxStatusCode);
                if (
                    bankAccountType === AccountTypes.NRI ||
                    bankAccountType === AccountTypes.NRO ||
                    isNRI
                ) {
                    alert('New purchase is not allowed for NRI/NRO investors');
                    props.history.goBack();
                }
            } catch (err: any) {
                // console.log(err.message);
            } finally {
                setLatestDataCalled(true);
            }
        }
        async function getCountries() {
            try {
                const { body } = await props.getCountries(); // Use Reducer state;
                const { countries: masterData = [] }: any = body;
                setCountries(masterData);
            } catch (err: any) {
                alert(err.message);
            }
        }
        getCountries();
        if (props.history.action !== 'POP' || purchaseDetails.defaultInit) {
            getInvestorDetails(); // ignoring for back navigation (i.e using store data);
            // dispatch({
            //     type: UPDATE_PURCHASE_INFO,
            //     body: { nomineeFlag: false },
            // });
        } else {
            setLatestDataCalled(true);
        }
        async function getNewSchemeDetails() {
            try {
                const { body = { data: {} as any } }: any = await props.getNewSchemeDetail({
                    isin: isin,
                    amcCode: !!amcCode ? amcCode : '',
                });
                if (body.data[0].activeFlag === IsAllow.No) {
                    setActiveHandle(true);
                }
                setSchemeAMC(body.data?.[0]?.amc);
                const details = formatRtaResponse(body.data);
                let { sip = null, bool: sipAllow } = isSipAllowed(details.sip);
                sortSip(sip);
                setAddPurchaseDetails({
                    ...details.additionalPurchase,
                    multiples:
                        !details.additionalPurchase?.multiples ||
                        Number(details.additionalPurchase?.multiples) < 1
                            ? 1
                            : Number(details.additionalPurchase?.multiples),
                });
                setNewPurchaseDetails({
                    ...details.freshPurchase,
                    multiples:
                        !details.freshPurchase?.multiples ||
                        Number(details.freshPurchase?.multiples) < 1
                            ? 1
                            : Number(details.freshPurchase?.multiples),
                });
                setSipDetails(sip);
                setSubPlans(details.subPlans);
                setCommonDetails({
                    ...details.commonDetails,
                    sipAllow:
                        details.commonDetails.sipAllow === IsAllow.YES
                            ? sipAllow
                            : details.commonDetails.sipAllow,
                });
                setScheme((prevSchemeData: any) => ({
                    ...prevSchemeData,
                    frequency: schemeInfo.frequency
                        ? schemeInfo.frequency
                        : Object.keys(details.sip)[0],
                }));
            } catch (err: any) {
                alert(err.message);
                props.history.goBack();
            } finally {
                setRtaSchemeCalled(true);
            }
        }
        getNewSchemeDetails();
        async function init() {
            try {
                let body = await dispatch(getAmcList());
                setamcList(body);
            } catch (err: any) {
                alert(err.message);
            }
        }
        init();
        //cleanup
        return () => {
            if (clearData.current) {
                dispatch({ type: CLEAR_SCHEME_INFO });
                dispatch({ type: CLEAR_SIP_OR_LUMPSUM });
            }
        };
    }, []);
    useEffect(() => {
        if (!!sipDetails) {
            setInstallmentIndex(calculateInstallment(installment_diff, sipDetails, currentScheme));
        }
    }, [installment_diff, currentScheme?.frequency]);

    useEffect(() => {
        if (folios.length > 0) {
            setCurrentFolio(folios[0]);
        }
    }, [folios]);

    useEffect(() => {
        let installmentKey =
            !!sipDetails &&
            currentScheme?.frequency &&
            sipDetails[currentScheme?.frequency as string]?.minimumInstallments[
                calculateInstallment(installment_diff, sipDetails, currentScheme)
            ];
        //reset sip day to first value (1=Mon for Motilal weekly, otherwise day-of-month)
        if (isMotilalWeekly(commonDetails?.amc, currentScheme?.frequency)) {
            setSipDay(MOTILAL_WEEKLY_DAYS[0].value);
        } else {
            setSipDay(
                getSipDays(
                    !!sipDetails
                        ? sipDetails[
                              !!currentScheme.frequency ? currentScheme.frequency : 'Monthly'
                          ]?.dates || []
                        : [],
                )[0],
            );
        }
        const sipDayList = !!sipDetails
            ? sipDetails[!!currentScheme.frequency ? currentScheme.frequency : 'Monthly']?.dates ||
              []
            : [];
        if (kfinFlag && isWeekdayNamedArray(sipDayList) && sipDayList?.length > 1 && !!sipDayList[0]) {
            setSelectedWeekday(sipDayList[0]);
        } else {
            setSelectedWeekday(null);
        }
        setInstallment(!!installmentKey ? installmentKey.installment : 1);
    }, [currentScheme?.frequency, sipDetails, commonDetails?.amc]);

    const [openDrawer, setDrawer] = useState<boolean>(false);
    const [bankDetails, setBankDetails] = useState<BankDetailsType>(bankDetailsInitState);
    const [countries, setCountries] = useState<any>();
    const filteredFatca = purchaseDetails.fatcaDetails.find((fatca: any) => fatca.fatcaId === 'FH');
    const { taxResidency = [] } = filteredFatca || {};

    useEffect(() => {
        setScheme(schemeInfo);
    }, [schemeInfo]);

    useEffect(() => {
        if (!!commonDetails && !!data) {
            const foliosForAmc = getFoliosFromAmc(
                data,
                commonDetails.amc,
                apDividendFilters.filter((f) => f !== portfoliosByPurchaseAllow),
            );
            const folios = foliosForAmc?.folios || [];
            setFolios(folios);
            if (folios.length > 0 && !folioPurchaseType) {
                dispatch({
                    type: SET_FOLIO_PURCHASE_TYPE,
                    body: folioPurchaseEnum.EXISTING,
                });
            } else if (
                !folios.length &&
                (folioPurchaseType === folioPurchaseEnum.EXISTING || folioPurchaseType === '')
            ) {
                dispatch({
                    type: SET_FOLIO_PURCHASE_TYPE,
                    body: folioPurchaseEnum.NEW,
                });
            }
            setFilterFolioSchemes(foliosForAmc?.schemes || []);
        }
    }, [data, commonDetails]);

    useEffect(() => {
        let perpetualDate = OTM_MAX_DATE(startDate);
        if (currentScheme.frequency === freqType.M) {
            perpetualDate = new Date(perpetualDate.getFullYear(), perpetualDate.getMonth(), sipDay);
        }
        !!perpetual ? setEndDate(perpetualDate) : resetEndDate();
    }, [perpetual, currentScheme?.frequency, sipDay]);

    const validateArnFields = async (Values: ArnPayloadType) => {
        try {
            await dispatch(validateArn(Values));
        } catch (err: any) {
            throw err;
        }
    };
    useEffect(() => {
        if (amcList) {
            let body = amcList.body;
            body?.some((val: any) => {
                if (val.amc_code == commonDetails?.amc) {
                    if (val.rta_code == 'KFIN') {
                        setkfinFlag(true);
                    }
                    setkfinFlagSet(true);
                }
            });

            // console.log('actype',acctype)
        }
    }, [amcList, commonDetails]);
    // console.log('bankdetails: ', accCode)
    const handleInvest = (options: any) => async (callBackArgs: any) => {
        const isInvestLater = options?.later;
        clearData.current = false;
        if (purchaseType === PaymentTypes.SIP) {
            if (commonDetails?.amc === 'RMF' && commonDetails?.scheme.slice(0, 2) === 'SC') {
                if (Number(currentScheme?.amount) > NIPPON_MAX_AMOUNT) {
                    throw new Error('Amount cannot be greater than 200,000');
                }
            }
        }
        if (!termsAccept.checked) {
            setTermsAccept({ ...termsAccept, message: dbCommercial.errors.termsAndCondition });
            return;
        }
        if (!!commonDetails) {
            if (purchaseType === PaymentTypes.Lumpsum && commonDetails.purAllow === 'N') {
                throw new Error('One time purchase is not allowed for this scheme');
            }
            if (purchaseType === PaymentTypes.SIP && commonDetails.sipAllow === 'N') {
                throw new Error('SIP is not allowed for this scheme');
            }
            if (currentScheme.frequency === freqType.D || currentScheme.frequency === freqType.DZ) {
                const startDateDayOfWeek = startDate.getDay();
                const endDateDayofWeek = endDate.getDay();
                if (isWeekend(startDateDayOfWeek) || isWeekend(endDateDayofWeek)) {
                    throw new Error('Weekend Days cannot be selected for Daily Frequency');
                }
            }
            const {
                default: bankDefault,
                ifscInfo,
                ..._bank
            }: any = purchaseDetails.bank.find(({ default: _d }: any) => _d === IsAllow.YES);
            const { ISIN, folioNo, investMode, riaFlag, ...schemeOption }: any = {
                ...currentScheme,
            };
            let response: any = {};
            const nominee: Nominee[] = purchaseDetails.nominees.map(
                (nominee: any, index: number) => {
                    const {
                        name,
                        relation,
                        percentage,
                        dob,
                        address1,
                        address2,
                        address3,
                        city,
                        nomineeGuardian,
                        state,
                        pan,
                        country,
                        pincode,
                        email,
                        mobile,
                        docName,
                        docValue,
                        gender,
                        addressSameAsFH,
                    } = nominee;
                    const data: Nominee = {
                        id: `${index + 1}`,
                        addressSameAsFH: kfinFlag ? 'N' : addressSameAsFH,
                        name,
                        relation,
                        percentage,
                        nomineeGuardian: {
                            ...nomineeGuardian,
                            dob: getDateString(nomineeGuardian?.dob),
                        },
                        email,
                        mobile,
                        docName,
                        docValue,
                        pan,
                        address1:
                            addressSameAsFH === 'Y'
                                ? kfinFlag
                                    ? purchaseDetails?.address?.line1
                                    : ''
                                : address1,
                        address2:
                            addressSameAsFH === 'Y'
                                ? kfinFlag
                                    ? purchaseDetails?.address?.line2
                                    : ''
                                : address2,
                        address3: country !== 'India' && kfinFlag ? pincode : '',
                        state:
                            addressSameAsFH === 'Y'
                                ? kfinFlag
                                    ? purchaseDetails?.address?.state
                                    : ''
                                : state,
                        country:
                            addressSameAsFH === 'Y'
                                ? kfinFlag
                                    ? purchaseDetails?.address?.country
                                    : ''
                                : country,
                        pincode: getPinCode(nominee, kfinFlag, purchaseDetails?.address),
                        city:
                            addressSameAsFH === 'Y'
                                ? kfinFlag
                                    ? purchaseDetails?.address?.city
                                    : ''
                                : city,
                        dob: getDateString(dob),
                        gender,
                    };
                    return data;
                },
            );
            let purchasePayload: any;

            let trxnType = purchaseType === PaymentTypes.Lumpsum ? 'FP' : 'FSIP';
            if (isInvestLater) {
                trxnType = 'P';
            }
            const { pennyDropStatus, chequeFile } = props;

            // const shouldUploadCheque = pennyDropStatus?.nameMatchStatus == 'N'
            // const didRunPennyValidation = ['Y', 'N'].includes(pennyDropStatus?.nameMatchStatus)
            // Hardcoding the name to 'Cheque'
            const imagePayload =
                trxnType === 'P' ? { images: [{ ...chequeFile, name: 'Cheque' }] } : {};

            // console.log(shouldUploadCheque,pennyDropStatus,chequeFile)
            // console.log('image Payload === ',imagePayload)

            const payload: NewPurchasePayload = {
                amc: commonDetails?.amc,
                ...imagePayload,
                schemeOptions: [
                    {
                        ...schemeOption,
                        reInvest:
                            commonDetails.isDividend.toLowerCase() === 'true' && !!idcwDetails
                                ? idcwDetails.idcwOption
                                : ReInvestTypes.Growth,
                        isin:
                            commonDetails.isDividend.toLowerCase() === 'true' && !!idcwDetails
                                ? idcwDetails.isin
                                : commonDetails.isin,
                        trxnType,
                        folio:
                            folioPurchaseType === folioPurchaseEnum.NEW ? '' : schemeOption.folio,
                        startDate:
                            purchaseType === PaymentTypes.Lumpsum ? '' : getDateString(startDate),
                        endDate:
                            purchaseType === PaymentTypes.Lumpsum ? '' : getDateString(endDate),

                        trxnDate: '',
                        trxnTime: '',
                        riaCode: ![PlanTypes.R, PlanTypes.Reggular].includes(
                            commonDetails.planMode.toUpperCase() as PlanTypes,
                        )
                            ? formik.values.investThrough === InvestThrough.ria
                                ? `${formik.values.riaFlag}${formik.values.riaCode}`
                                : ''
                            : '',
                        distId:
                            [PlanTypes.R, PlanTypes.Reggular].includes(
                                commonDetails.planMode.toUpperCase() as PlanTypes,
                            ) && !!formik.values.distId
                                ? `${UI_KEYS.ARN}${formik.values.distId}`
                                : formik.values.investThrough === InvestThrough.direct
                                ? 'DIRECT'
                                : '',
                        subBrokerARN:
                            [PlanTypes.R, PlanTypes.Reggular].includes(
                                commonDetails.planMode.toUpperCase() as PlanTypes,
                            ) && !!formik.values.subBrokerARN
                                ? `${UI_KEYS.SUB_BROKER_CODE}${formik.values.subBrokerARN}`
                                : '',
                        subDist:
                            [PlanTypes.R, PlanTypes.Reggular].includes(
                                commonDetails.planMode.toUpperCase() as PlanTypes,
                            ) && !!formik.values.subDist
                                ? `${formik.values.subDist}`
                                : '',
                        euin:
                            [PlanTypes.R, PlanTypes.Reggular].includes(
                                commonDetails.planMode.toUpperCase() as PlanTypes,
                            ) && !!formik.values.euin
                                ? `${UI_KEYS.EUI_NO}${formik.values.euin}`
                                : formik.values.euin,
                        euinDeclarationFlag: [PlanTypes.R, PlanTypes.Reggular].includes(
                            commonDetails.planMode.toUpperCase() as PlanTypes,
                        )
                            ? formik.values.euinDeclarationFlag
                            : '',
                        maxSipTat:
                            !!sipDetails && purchaseType === PaymentTypes.SIP
                                ? sipDetails[currentScheme.frequency as string]?.maxSipTat
                                : '',
                        minSipTat:
                            !!sipDetails && purchaseType === PaymentTypes.SIP
                                ? sipDetails[currentScheme.frequency as string]?.minSipTat
                                : '',
                        noOfInstallments:
                            purchaseType === PaymentTypes.SIP ? installment_diff + 1 : '',
                        registrationDate: getDateString(new Date()),
                        registrationAmount: currentScheme.amount,
                        sipType: purchaseType === PaymentTypes.SIP ? 'SIP' : '',
                        frequency: purchaseType === PaymentTypes.SIP ? schemeOption.frequency : '',
                        investorName: purchaseDetails.investorName || investorName,
                        email: purchaseDetails.email || investorEmail,
                        // amount: schemeMaster.amount,
                    },
                ],
                investorDetails: {
                    bank: { ..._bank, bankDefault },
                    nominee: !nomineeFlag ? nominee : [],
                    fatcaDetails: fatcaDetails.map((fatca) => {
                        if (fatca.taxResidencyOtherthanIndia === IsAllow.No) {
                            return {
                                ...fatca,
                                countryOfBirth: 'IN',
                                nationality: 'IN',
                            };
                        }
                        return fatca;
                    }),
                    investorName: purchaseDetails.investorName || investorName,
                    gender: purchaseDetails.gender,
                    validPan: IsAllow.YES,
                    dob: getDateString(purchaseDetails.dob),
                    email: purchaseDetails.email || investorEmail,
                    mobile: purchaseDetails.mobile || investorMobile,
                    taxStatus: purchaseDetails.taxStatus,
                    occupation: purchaseDetails.occupation,
                    grossAnnualIncome: filteredFatca.netWorth,
                    emailRelationship: purchaseDetails.emailRelationship,
                    mobileRelationship: purchaseDetails.mobileRelationship,
                    nomineeInSoa: purchaseDetails.nomineeInSoa,
                    otpSentTo: '',
                    eNomType: 'F',
                    eNomMobileStatus: 'D',
                    eNomDocId: '',
                    eSignFlag: '',
                    noNominee: nomineeFlag ? 'Y' : 'N',
                    address: [purchaseDetails.address],
                    nriDeclarationFlag: '',
                    holdingMode: 'SI',
                    title: '',
                    dpid: '',
                    source: isMobileDevice() ? 'mobile' : 'web',
                    countryCode: '',
                    ckycNo: '',
                    kycStatus: '',
                    pep: filteredFatca.pepFlag,
                },
                instNo: '',
                omUMRN: '',
                mandateRefId: '',
                payInMode: '',
                payInRefno: '',
                payInBankName: '',
                payInBankAcno: '',
                tpvFlag: IsAllow.YES,
            };
            let errorMessage: string = '';
            let errorSection: ErrorSectionTypes | null = null;
            let sectionPayload: any;
            const extraOptions = {
                chequeFile: chequeFile as ChequeFile,
                pennyDropStatus: pennyDropStatus as PennyDropStatus,
            };
            // console.log('purchase == ',folioPurchaseType,didRunPennyValidation,pennyDropStatus)
            const bank = props.purchaseDetails?.bank?.[0];

            if (investLaterClicked) {
                setLoading(2);
            } else {
                setLoading(1);
            }

            // const validatePennyDrop = async () => {

            //     if (folioPurchaseType === folioPurchaseEnum.NEW) {

            //         if (!didRunPennyValidation) {

            //             try {
            //                 console.log('running alidation penny drop!!', bank)
            //                 const res = await props.performPennyDropValidation({
            //                     investorName: props.purchaseDetails.investorName || '',
            //                     accountNo: bank?.accountNo,
            //                     ifsc: bank?.ifsc
            //                 }, amcCode)

            //                 const nameMatchStatus = res?.body?.data?.[0].nameMatchStatus
            //                 console.log('pennydrop message =', res?.body)

            //                 // This will trigger the validation below
            //                 pennyDropStatus.nameMatchStatus = nameMatchStatus

            //                 // if(nameMatchStatus == 'N'){
            //                 // }
            //                 return res

            //             } catch (error: any) {

            //                 // Make bank validation fail, to make cheque upload as required
            //                 pennyDropStatus.nameMatchStatus = 'N'
            //                 // setLoading(0)
            //                 // return alert(error.message)
            //             }
            //         }
            //     }

            // }

            const validationFunctions =
                folioPurchaseType === folioPurchaseEnum.EXISTING
                    ? AdditionalPurchaseValidations
                    : NewPurchaseValidations;

            let isError;
            for (let i in validationFunctions) {
                const func = validationFunctions[i];
                // const isLastFilter = (i == String(validationFunctions.length - 1))
                // NOTE: remove the isNewToMF below to run penny-drop for non-new investors as well
                // if (isLastFilter && isNewToMF && loading === 2) {
                //     await validatePennyDrop()
                // }

                let {
                    error,
                    message = '',
                    section,
                } = (sectionPayload = func.apply({}, [
                    {
                        ...payload,
                        investorDetails: {
                            ...payload.investorDetails,
                            nomineeFlag: nomineeFlag,
                            invNameValid: callBackArgs.invNameValid,
                            invDobValid: callBackArgs.invDobValid,
                            panRemarks: callBackArgs.panSeededRemarks,
                        },
                    },
                    {
                        plan: commonDetails.planMode,
                        investingThrough: formik.values.investThrough,
                        euinCheckFlag: formik.values.euinCheck,
                        ...extraOptions,
                    },
                ]));

                errorMessage = message;
                errorSection = section as ErrorSectionTypes;

                // console.log(error,' ')

                if (error) {
                    isError = true;
                    break;
                }
            }

            try {
                if (isError) {
                    alert(errorMessage);

                    // Redirect to bank page if cheque needs to be uploaded
                    if (errorSection == ErrorSectionTypes.BankDetails) {
                        if (shouldUploadChequeButDidNot(props)) {
                            props.history.push(`${CommercialRootPath}/${isin}/edit/bank`, {
                                bankDetails: { ...bank, kfinFlag },
                            });
                            // alert(dbCommercial.exploreMfs.errors.chequeRequired)
                            return;
                        }
                    }

                    if (typeof sectionPayload.section === 'number') {
                        saveAndProceed({ section: sectionPayload });
                        return;
                    }
                    throw new Error(errorMessage);
                }
                if (purchaseType === SEGMENTS[1]) {
                    if (installment_diff % 1 !== 0 && !perpetual) {
                        throw new Error(dbCommercial.sip.errors.invalidInstallment);
                    }
                    const expectedDay = isMotilalWeekly(
                        commonDetails?.amc,
                        currentScheme?.frequency,
                    )
                        ? startDate.getDay()
                        : startDate.getDate();
                    if (sipDay !== expectedDay) {
                        throw new Error(dbCommercial.sip.errors.sipDay);
                    }
                }
                const shouldArnValidated =
                    formik.values.investThrough === InvestThrough.arn ||
                    formik.values.investThrough === InvestThrough.ria;

                const { distId, subDist, subBrokerARN, euin, euinDeclarationFlag, riaCode } =
                    payload.schemeOptions[0];
                if (shouldArnValidated && !options?.nav) {
                    await validateArnFields({
                        distId,
                        subDist,
                        subBrokerARN,
                        euin,
                        euinDeclarationFlag,
                        riaCode,
                        planCode: commonDetails.planMode as PlanTypes,
                        amc: payload.amc,
                    });
                }
                if (folioPurchaseType === folioPurchaseEnum.EXISTING) {
                    if (!bankDetails.ifsc) {
                        setIfscError(true);
                        return;
                    }
                    let fatcaData = null;
                    let shouldCallApi =
                        !fatcaStatusData ||
                        fatcaStatusData[0]?.fhFatcaStatus !== IsAllow.YES ||
                        fatcaStatusData[1]?.fhFatcaStatus !== IsAllow.YES;
                    if (shouldCallApi) {
                        const { body } = await props.checkFatca();
                        fatcaData = body.data;
                    }
                    if (!currentFolio) {
                        throw new Error(dbCommercial.additionalPurchase.errors.emptyFolio);
                    }
                    const { investorDetails, ...apPayload } = payload;
                    const { schemeOptions: addSchemeOptions, ...extra } = apPayload;
                    const additionalPurchasePayload = {
                        data: [
                            {
                                schemeOptions: [
                                    {
                                        ...addSchemeOptions[0],
                                        folio: currentFolio,
                                        trxnType:
                                            purchaseType === PaymentTypes.Lumpsum ? 'AP' : 'ASIP',
                                        investorName:
                                            filterFolioSchemes.find(
                                                (scheme) => `${scheme.folio}` === currentFolio,
                                            )?.investorName || '',
                                        email:
                                            filterFolioSchemes.find(
                                                (scheme) => `${scheme.folio}` === currentFolio,
                                            )?.email || '',
                                    },
                                ],
                                ...extra,
                                source: isMobileDevice() ? 'mobile' : 'web',
                                payInMode: 'web',
                                bank: bankDetails || {},
                            },
                        ],
                    };
                    if (
                        isFatcaVerified(
                            fatcaStatusData || fatcaData || [],
                            filterFolioSchemes[0]?.rtaName,
                        )
                    ) {
                        if (options?.nav) {
                            setShowNavDialog(true);
                            return;
                        }
                        response = await dispatch(
                            makeAdditionalPurchase(additionalPurchasePayload),
                        );
                        purchasePayload = { ...additionalPurchasePayload.data[0] };
                    } else {
                        setShowFatcaDialog(true);
                        return;
                    }
                } else {
                    if (options?.nav) {
                        setShowNavDialog(true);
                        return;
                    }
                    if (isInvestLater) {
                        const res = await props.sendEmailOTP({
                            action: OTP_ACTIONS.PROSPECT_FOLIO_EMAIL,
                            email: payload.investorDetails.email,
                        });
                        props.history.push(`${CommercialRootPath}${ExplorePaths.OtpVerify}`, {
                            apiPayload: payload,
                            prospectFlag: true,
                            action: OTP_ACTIONS.PROSPECT_FOLIO_EMAIL,
                            reqId: res.body.reqId,
                            otpRef: res.body.otpRef,
                        });
                        return;
                    } else {
                        response = await dispatch(makeNewPurchase(payload));
                    }

                    purchasePayload = { ...payload };
                }
                const { body = {} } = response;
                const { pending: success = [], reqId } = body;
                const [data = {}] = success;
                const apiPayload = {
                    ...purchasePayload,
                    schemeName: !!commonDetails ? commonDetails.schemeName : '',
                    logoUrl: !!commonDetails
                        ? `/images/fav-logos/${favLogos[commonDetails.amc] || 'default'}.svg`
                        : `/images/fav-logos/default.svg`,
                    investorDetails: {
                        ...(purchasePayload?.investorDetails || {}),
                        bank:
                            folioPurchaseType === folioPurchaseEnum.EXISTING
                                ? bankDetails
                                : payload.investorDetails.bank,
                    },
                };
                const otpPayload = {
                    reqId,
                    action:
                        folioPurchaseType === folioPurchaseEnum.EXISTING
                            ? OTP_ACTIONS.additionalPurchase
                            : OTP_ACTIONS.FRESH_PURCHASE_EMAIL,
                };
                // For additional purchase we will send directly otp to registered one.
                const res =
                    folioPurchaseType === folioPurchaseEnum.EXISTING
                        ? await props.sendOtp(otpPayload)
                        : props.userRegisteredWith === RegisterWith.Mobile
                        ? await props.sendEmailOTP({
                              ...otpPayload,
                              email: apiPayload.investorDetails.email,
                          })
                        : await props.sendOtp(otpPayload);
                // preserve investment mode info for back navigations
                dispatch({
                    type: SET_SCHEME_INFO,
                    body: { ...currentScheme, sipType: purchaseType, investMode: formik.values },
                });
                props.history.push(`${CommercialRootPath}${ExplorePaths.OtpVerify}`, {
                    reqId: res.body.reqId,
                    apiPayload,
                    userTrxnNo: data.userTrxnNo,
                    otpRef: res.body.otpRef,
                    action: otpPayload.action,
                });
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(0);
            }
        }
    };

    const handleInvestLater = async () => {
        handleInvest({ later: true });
    };

    const handleViewMore = () => {
        //do not clear data on unmount
        clearData.current = false;
        dispatch({
            type: SET_SCHEME_INFO,
            body: {
                ...currentScheme,
                folioNo: currentFolio,
                investMode: formik.values,
            },
        });

        dispatch({
            type: SET_SIP_OR_LUMPSUM,
            body: {
                sipOrLumpsum: purchaseType,
            },
        });
        !!commonDetails &&
            props.history.push(`/portal/commercial/${commonDetails.isin}/explore`, {
                buttonDisable: true,
            });
    };

    const handleEdit = () => {
        //do not clear data on unmount
        clearData.current = false;
        saveAndProceed();
    };

    const saveAndProceed = (state = {}) => {
        dispatch({
            type: SET_SCHEME_INFO,
            body: { ...currentScheme, sipType: purchaseType, investMode: formik.values },
        });
        dispatch({
            type: SET_SIP_OR_LUMPSUM,
            body: {
                sipOrLumpsum: purchaseType,
            },
        });
        props.history.push(`${CommercialRootPath}/${isin}/edit`, { ...state, kfinFlag });
    };

    //UI-PARTS-FOR-CONDITIONAL-RENDERING
    const ProfileDetails = () => {
        return (
            <div className="mf-investment-right">
                <div className="heading">
                    <h4>
                        {dbCommercial.exploreMfs.mfInvestment.profileDetails}
                        {!apiPendingActions.includes(GET_INVESTOR_LATEST_DETAILS) && (
                            <a onClick={handleEdit}>
                                <img src="/images/edit-purple.svg" alt="icon" />
                            </a>
                        )}
                    </h4>
                    <p>
                        <img src="/images/exclaim.svg" alt="icon" />
                        {dbCommercial.exploreMfs.mfInvestment.prefilled}
                    </p>
                    <p style={{ fontWeight: 'bold' }}>
                        {dbCommercial.exploreMfs.mfInvestment.nsdl}
                    </p>
                </div>
                <details open>
                    <summary>
                        <AsyncLoader
                            skelton={<TabElementSkeleton height={35} width={200} />}
                            data={latestDataCalled}
                        >
                            <>{dbCommercial.exploreMfs.mfInvestment.personalDetails}</>
                        </AsyncLoader>
                        <img src="/images/down-arrow-grey.svg" alt="icon" />
                    </summary>
                    <div className="profile-details">
                        <div className="profile-details-info">
                            <div className="profile-details-txt">
                                <AsyncLoader
                                    skelton={<TabElementSkeleton width={60} />}
                                    data={latestDataCalled}
                                >
                                    <p>{dbCommercial.exploreMfs.mfInvestment.name}</p>
                                </AsyncLoader>
                                <AsyncLoader
                                    skelton={<TabElementSkeleton />}
                                    data={latestDataCalled}
                                >
                                    <h6>{purchaseDetails.investorName || investorName}</h6>
                                </AsyncLoader>
                            </div>
                            <div className="profile-details-txt">
                                <AsyncLoader
                                    skelton={<TabElementSkeleton width={75} />}
                                    data={latestDataCalled}
                                >
                                    <p>{dbCommercial.exploreMfs.mfInvestment.panNo}</p>
                                </AsyncLoader>
                                <AsyncLoader
                                    skelton={<TabElementSkeleton />}
                                    data={latestDataCalled}
                                >
                                    <h6>{pan}</h6>
                                </AsyncLoader>
                            </div>
                            <div className="profile-details-txt">
                                <AsyncLoader
                                    skelton={<TabElementSkeleton width={50} />}
                                    data={latestDataCalled}
                                >
                                    <p>{dbCommercial.exploreMfs.mfInvestment.moh}</p>
                                </AsyncLoader>
                                <AsyncLoader
                                    skelton={<TabElementSkeleton />}
                                    data={latestDataCalled}
                                >
                                    <h6>{purchaseDetails.modeOfHolding}</h6>
                                </AsyncLoader>
                            </div>
                        </div>
                    </div>
                </details>
                <details>
                    <summary>
                        <AsyncLoader
                            skelton={<TabElementSkeleton height={35} width={200} />}
                            data={latestDataCalled}
                        >
                            <>{dbCommercial.exploreMfs.mfInvestment.nomineeDetails}</>
                        </AsyncLoader>
                        <img src="/images/down-arrow-grey.svg" alt="icon" />
                    </summary>
                    <div className="profile-details">
                        {purchaseDetails.nomineeFlag ? (
                            <div className="profile-details-txt">
                                <p>{dbCommercial.profileDetails.nominees.noNominee}</p>
                            </div>
                        ) : (
                            purchaseDetails.nominees.map((nominee: any, index: number) => {
                                return (
                                    <div className="profile-details-info">
                                        <h2>{`Nominee ${index + 1}`}</h2>
                                        <div className="profile-details-txt">
                                            <p>{dbCommercial.exploreMfs.mfInvestment.name}</p>
                                            <h6>{nominee.name}</h6>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </details>
                <details>
                    <summary>
                        <AsyncLoader
                            skelton={<TabElementSkeleton height={35} width={200} />}
                            data={latestDataCalled}
                        >
                            <>{dbCommercial.exploreMfs.mfInvestment.bankDetails}</>
                        </AsyncLoader>
                        <img src="/images/down-arrow-grey.svg" alt="icon" />
                    </summary>
                    <div className="profile-details">
                        <div className="profile-details-info">
                            <h2>{purchaseDetails.bank[0]?.name}</h2>
                            <div className="profile-details-txt">
                                <p>{dbCommercial.exploreMfs.mfInvestment.bank.accountNo}</p>
                                <h6>{purchaseDetails.bank[0]?.accountNo}</h6>
                            </div>
                            <div className="profile-details-txt">
                                <p>{dbCommercial.exploreMfs.mfInvestment.bank.name}</p>
                                <h6>{purchaseDetails.bank[0]?.name}</h6>
                            </div>
                            <div className="profile-details-txt">
                                <p>{dbCommercial.exploreMfs.mfInvestment.bank.ifsc}</p>
                                <h6>{purchaseDetails.bank[0]?.ifsc}</h6>
                            </div>
                            <div className="profile-details-txt">
                                <p>{dbCommercial.exploreMfs.mfInvestment.bank.branch}</p>
                                <h6>{purchaseDetails.bank[0]?.branch}</h6>
                            </div>
                        </div>
                    </div>
                </details>
                <details>
                    <summary>
                        <AsyncLoader
                            skelton={<TabElementSkeleton height={35} width={200} />}
                            data={latestDataCalled}
                        >
                            <>{dbCommercial.exploreMfs.mfInvestment.fatcaDetails}</>
                        </AsyncLoader>
                        <img src="/images/down-arrow-grey.svg" alt="icon" />
                    </summary>
                    <div className="profile-details">
                        {factaDetailsByHolder?.declaration === IsAllow.No ? (
                            <div className="profile-details-txt">
                                <p>{dashboard.FatcaDeclaration.taxResident}</p>
                                <h6>{'No'}</h6>
                            </div>
                        ) : (
                            <div className="profile-details-info">
                                <div className="profile-details-txt">
                                    <p>
                                        {dbCommercial.exploreMfs.mfInvestment.fatca.countryOfBirth}
                                    </p>
                                    {factaDetailsByHolder?.countryOfBirth}
                                </div>
                                <div className="profile-details-txt">
                                    <p>{dbCommercial.exploreMfs.mfInvestment.fatca.nationality}</p>
                                    {factaDetailsByHolder?.nationality}
                                </div>
                                {taxResidency.length
                                    ? taxResidency.map((info: any, index: number) => (
                                          <div key={index} className="profile-details-txt">
                                              <p>
                                                  {dbCommercial.exploreMfs.mfInvestment.fatca.tin} -{' '}
                                                  {index + 1}
                                              </p>
                                              <h6>{info?.taxId}</h6>
                                          </div>
                                      ))
                                    : null}
                            </div>
                        )}
                    </div>
                </details>
            </div>
        );
    };
    const AdditionalPurchaseDetails = (
        <div className="mf-investment-right">
            <div className="heading">
                <h4>
                    {dbCommercial.additionalPurchase.investmentPage.rightHeading}
                    <a onClick={handleViewMore}>View More</a>
                </h4>
                <div className="profile-details">
                    <div className="profile-details-info">
                        <div className="profile-details-txt">
                            <p>{dbCommercial.additionalPurchase.investmentPage.pan}</p>
                            <h6> {`${props.pan}`}</h6>
                        </div>
                        <br />
                        <div className="profile-details-txt">
                            <h6> {`${!!commonDetails ? commonDetails.schemeName : ''}`}</h6>
                        </div>
                        <SelectBank
                            amc={!!commonDetails ? commonDetails.amc : ''}
                            folioNo={!!currentFolio ? currentFolio : folios[0]}
                            handleBankDetails={setBankDetails}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    const validateLumpsumAmount = (value: string | number) => {
        if (!newPurchaseDetails) return false;
        const _value = Number(value);
        const isinFlag = portfolioHasIsin(data, isin);
        const folioNotNew = !isFolioNew(data, currentFolio);
        const minAmount =
            (folioPurchaseType === folioPurchaseEnum.EXISTING && isinFlag && folioNotNew
                ? addPurchaseDetails?.minAmount
                : newPurchaseDetails.minAmount) || 1;
        const step =
            (folioPurchaseType === folioPurchaseEnum.EXISTING && isinFlag && folioNotNew
                ? addPurchaseDetails?.multiples
                : newPurchaseDetails.multiples) || 1;
        return _value % Number(step) === 0 && _value >= Number(minAmount);
    };

    const validateSipAmount = (value: string | number) => {
        if (!sipDetails) return false;
        const sipData = sipDetails[currentScheme.frequency || 'Monthly'];
        const minAmount = sipData?.minimumInstallments[installmentIndex].minAmount || 1;
        // const maxAmount =
        //     sipData?.minimumInstallments[installmentIndex].maxAmount || DEFAULT_MAX_INVESTMENT;
        const step = sipData?.multiples || 1;
        return (
            Number(value) % Number(step) === 0 && Number(value) >= Number(minAmount)
            // && Number(value) <= maxAmount
        );
    };

    const disableInvestment = (): boolean => {
        if (!!loading) {
            return true;
        }

        const isAllow = !!commonDetails
            ? (commonDetails.sipAllow === IsAllow.No && commonDetails.purAllow === IsAllow.No) ||
              !!errors.amount ||
              !(
                  currentScheme.amount &&
                  (purchaseType === PaymentTypes.Lumpsum
                      ? validateLumpsumAmount(currentScheme.amount)
                      : validateSipAmount(currentScheme.amount))
              )
            : false;

        return isAllow;
    };

    function handleKYCFailure() {
        const comingFromPrelogin = props.isFromPreLogin;
        if (comingFromPrelogin) {
            props.history.push(`explore`);

            // clear the comingFromPrelogin
            dispatch({
                type: SET_IS_FROM_PRE_LOGIN,
                body: false,
            });
        } else {
            props.history.goBack();
        }
    }
    const isNewToMF = newToMF === 'Y';

    let currentFolioDetails = filterFolioSchemes.find(
        (scheme: any) => `${scheme.folio}` === currentFolio,
    );

    const [callPanSeed, setCallPanSeed] = useState(false);
    const [matchPan, setMatchPan] = useState(false);
    const [investLaterClicked, setInvestLaterClicked] = useState(false);

    const resetMatchTrigger = () => {
        setMatchPan(false);
    };

    const resetTrigger = () => {
        setCallPanSeed(false);
    };

    return (
        <div className="curved-bg mf-investment">
            <KYCCheck
                handleKYCFailure={handleKYCFailure}
                allowRegistration={{ isin, amc: amcCode }}
            />
            {latestDataCalled && kfinFlagSet && (
                <PanSeedCheckNew
                    customPayload={{
                        trxnMode: 'FT',
                        amc: amcCode,
                        folio: '',
                        taxStatus: '01',
                        trxnType: isNewToMF ? TRXN_TYPE_MAP.prospect : TRXN_TYPE_MAP.newPurchase,
                        invName: purchaseDetails.investorName || 'dummy',
                        invDob: kfinFlag
                            ? getKfinFormatDate(purchaseDetails.dob || '12-APR-1900')
                            : getDateString(purchaseDetails.dob) || '12-APR-1900',
                    }}
                    ignoreTrxnValid={true}
                    callBackFn={() => {}}
                    triggerCheck={true}
                />
            )}
            {kfinFlagSet && (
                <PanSeedCheckNew
                    customPayload={{
                        trxnMode: 'FT',
                        amc: amcCode,
                        folio: '',
                        taxStatus: '01',
                        trxnType: isNewToMF ? TRXN_TYPE_MAP.prospect : TRXN_TYPE_MAP.newPurchase,
                        invName: purchaseDetails.investorName || 'dummy',
                        invDob: kfinFlag
                            ? getKfinFormatDate(purchaseDetails.dob || '12-APR-1900')
                            : getDateString(purchaseDetails.dob) || '12-APR-1900',
                    }}
                    triggerCheck={matchPan}
                    resetTrigger={resetMatchTrigger}
                    callBackFn={handleInvest({ later: investLaterClicked, nav: true })}
                />
            )}
            {folioPurchaseType === folioPurchaseEnum.EXISTING && currentFolioDetails && (
                <PanSeedCheckNew
                    foliosArray={[currentFolioDetails]}
                    callBackFn={handleInvest({ later: false, nav: true })}
                    resetTrigger={resetTrigger}
                    triggerCheck={callPanSeed}
                    trxnMode="FT"
                    trxnType={
                        purchaseType === PaymentTypes.Lumpsum
                            ? TRXN_TYPE_MAP.additionalPurchase
                            : TRXN_TYPE_MAP.additionalPurchaseSip
                    }
                />
            )}
            {props.kycVerified.value === IsAllow.YES &&
                folioPurchaseType === folioPurchaseEnum.NEW && (
                    <OTMCheck
                        amc={amcCode}
                        setPurchaseType={setPurchaseType}
                        purchaseType={purchaseType}
                        otmVerifyStatus={otmVerifyStatus}
                        setOtmVerifyStatus={setOtmVerifyStatus}
                    />
                )}
            <FatcaCheck
                rtaName={filterFolioSchemes[0]?.rtaName}
                cancelCallBack={(setError: Dispatch<SetStateAction<boolean>>) => {
                    setError(false);
                    setShowFatcaDialog(false);
                }}
                callApi={false}
                showDialog={showFatcaDialog}
            />
            <div className="explore-mf-heading">
                {!!commonDetails && (
                    <h2 className="heading">
                        <a onClick={() => props.history.goBack()}>
                            <img src="/images/left-arrow-black.svg" alt="icon" />
                        </a>
                        <div className="mf-logo">
                            <img
                                src={`/images/fav-logos/${favLogos[commonDetails.amc]}.svg`}
                                alt=""
                                className="list-logo"
                            />
                        </div>
                        <div className="explore-mf-details-fund-name">
                            {commonDetails.schemeName}
                        </div>
                    </h2>
                )}

                <div className="mobile-profile-details mobile_mode">
                    <div className="mobile-profile-details-inner">
                        <h4>{dbCommercial.exploreMfs.mfInvestment.profileDetails}</h4>
                        <div className="mobile-profile-details-links">
                            <a onClick={() => setDrawer(true)}>
                                View <img src="/images/right-arrow-purple.svg" alt="icon" />
                            </a>
                            <a onClick={handleEdit}>
                                Edit <img src="/images/right-arrow-purple.svg" alt="icon" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="curved-bg-content">
                {!!loading && (
                    <div
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            left: 0,
                            top: 0,
                            background: 'rgba(0,0,0,0)',
                            zIndex: 999,
                        }}
                    ></div>
                )}
                <div className="mf-investment-left">
                    {!!folios && folios.length > 0 && (
                        <div className="radio-div">
                            <AsyncLoader
                                skelton={<TabElementSkeleton width={300} height={35} />}
                                data={rtaSchemeCalled}
                            >
                                <>
                                    <p>{dbCommercial.exploreMfs.mfInvestment.purchaseType}</p>
                                    <CustomRadio
                                        name="folio-type"
                                        list={[
                                            {
                                                label: dbCommercial.exploreMfs.mfInvestment
                                                    .existing,
                                                value: folioPurchaseEnum.EXISTING,
                                            },
                                            {
                                                label: dbCommercial.exploreMfs.mfInvestment.new,
                                                value: folioPurchaseEnum.NEW,
                                            },
                                        ]}
                                        selectedValue={folioPurchaseType}
                                        handleRadioChange={(value: string) => {
                                            dispatch({
                                                type: SET_FOLIO_PURCHASE_TYPE,
                                                body: value,
                                            });
                                            setScheme((prev) => ({
                                                ...initialSchemeInfo,
                                                frequency: prev.frequency,
                                            })); // empty after folio change
                                        }}
                                    />
                                </>
                            </AsyncLoader>
                        </div>
                    )}
                    {!!folios &&
                        folios.length > 0 &&
                        folioPurchaseType === folioPurchaseEnum.EXISTING && (
                            <>
                                <FormControl variant="outlined" className="mf-investment-select">
                                    <Select
                                        labelId="mf-scheme-label"
                                        id="portfolio-sortby"
                                        value={currentFolio === '' ? folios[0] : currentFolio}
                                        onChange={(e: any) => {
                                            setCurrentFolio(e.target.value);
                                        }}
                                    >
                                        {folios.map((folio: string) => {
                                            let investorName = filterFolioSchemes.find(
                                                (scheme: any) => `${scheme.folio}` === currentFolio,
                                            )?.investorName;
                                            investorName = !!investorName ? `-${investorName}` : '';
                                            return (
                                                <MenuItem value={folio}>
                                                    {folio}
                                                    {investorName}
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                                <br />
                            </>
                        )}
                    <InvestThroughPage
                        planType={commonDetails?.planMode?.toUpperCase() as PlanTypes}
                        formik={formik}
                        showData={rtaSchemeCalled}
                        setEuin={setEuin}
                    />
                    <div className="investment-details">
                        <div className="idcw-options">
                            <h3>
                                <AsyncLoader
                                    skelton={<TabElementSkeletonRect width={25} height={25} />}
                                    data={rtaSchemeCalled}
                                >
                                    <img src="/images/investment-details.svg" alt="icon" />
                                </AsyncLoader>
                                <AsyncLoader
                                    skelton={<TabElementSkeleton width={160} height={35} />}
                                    data={rtaSchemeCalled}
                                >
                                    <>{dbCommercial.exploreMfs.mfInvestment.investmentDetails}</>
                                </AsyncLoader>
                            </h3>
                        </div>
                        {!!commonDetails &&
                            commonDetails.isDividend.toLowerCase() === 'true' &&
                            !!subPlans && (
                                <div className="idcw-options-dropdown">
                                    <IdcwOptions
                                        subPlans={subPlans}
                                        setIdcwDetails={setIdcwDetails}
                                    />
                                </div>
                            )}
                        <AsyncLoader
                            skelton={<TabElementSkeletonRect width={300} height={50} />}
                            data={rtaSchemeCalled}
                        >
                            <SegmentedControl
                                additionalClasses="portfolio-details-tabs portfolio-demat-tabs"
                                segments={['', '']}
                                segmentsSpan={SEGMENTS}
                                segmentsImage={[
                                    {
                                        active: 'inv-lumpsum-white.svg',
                                        inactive: 'inv-lumpsum.svg',
                                    },
                                    { active: 'inv-sip-white.svg', inactive: 'inv-sip.svg' },
                                ]}
                                onSegmentChanged={handleSegmentChange}
                                selectedSegmentIndex={SEGMENTS.findIndex(
                                    (str: string) => str === purchaseType,
                                )}
                                key={purchaseType}
                            />
                        </AsyncLoader>

                        <div className="investment-details-content">
                            {purchaseType === SEGMENTS[0] ? (
                                commonDetails?.purAllow === IsAllow.YES ? (
                                    <div className="investment-amount">
                                        <AsyncLoader
                                            skelton={<TabElementSkeleton width={160} height={35} />}
                                            data={rtaSchemeCalled}
                                        >
                                            <p>
                                                {dbCommercial.exploreMfs.mfInvestment.lumpsumAmount}
                                            </p>
                                        </AsyncLoader>

                                        <AsyncLoader
                                            skelton={
                                                <TabElementSkeletonRect width={220} height={50} />
                                            }
                                            data={rtaSchemeCalled}
                                        >
                                            <PurchaseInputField
                                                handleChange={setScheme}
                                                value={currentScheme}
                                                stateKey={API_KEYS.AMOUNT}
                                                maxLength={18}
                                                uiKey="₹"
                                                checkError={(value: string) =>
                                                    !validateLumpsumAmount(value)
                                                }
                                                showHelper={true}
                                                errorText={showHintTemplateForMaxAndMin({
                                                    min: getValueForNewPurchase(
                                                        folioPurchaseType,
                                                        isin,
                                                        data || [],
                                                        'minAmount',
                                                        newPurchaseDetails,
                                                        addPurchaseDetails,
                                                        currentFolio,
                                                    ),
                                                    max: getValueForNewPurchase(
                                                        folioPurchaseType,
                                                        isin,
                                                        data || [],
                                                        'maxAmount',
                                                        newPurchaseDetails,
                                                        addPurchaseDetails,
                                                        currentFolio,
                                                    ),
                                                    multiples: getValueForNewPurchase(
                                                        folioPurchaseType,
                                                        isin,
                                                        data || [],
                                                        'multiples',
                                                        newPurchaseDetails,
                                                        addPurchaseDetails,
                                                        currentFolio,
                                                    ),
                                                })}
                                                handleError={setErrors}
                                                handleTouch={setTouched}
                                                touched={touched}
                                            />
                                        </AsyncLoader>
                                    </div>
                                ) : (
                                    <div className="investment-amount">
                                        <AsyncLoader
                                            skelton={<TabElementSkeleton width={300} height={35} />}
                                            data={rtaSchemeCalled}
                                        >
                                            <>{dbCommercial.exploreMfs.mfInvestment.purAllow}</>
                                        </AsyncLoader>
                                    </div>
                                )
                            ) : commonDetails?.sipAllow === IsAllow.YES &&
                              Object.keys(sipDetails || {}).length > 0 ? (
                                <>
                                    <div className="investment-amount">
                                        <AsyncLoader
                                            skelton={<TabElementSkeleton width={160} height={35} />}
                                            data={rtaSchemeCalled}
                                        >
                                            <p>{dbCommercial.exploreMfs.mfInvestment.sipAmount}</p>
                                        </AsyncLoader>
                                        <AsyncLoader
                                            skelton={
                                                <TabElementSkeletonRect width={220} height={50} />
                                            }
                                            data={rtaSchemeCalled}
                                        >
                                            <PurchaseInputField
                                                handleChange={setScheme}
                                                value={currentScheme}
                                                maxLength={18}
                                                stateKey={API_KEYS.AMOUNT}
                                                showHelper={true}
                                                uiKey="₹"
                                                checkError={(value: string) =>
                                                    !validateSipAmount(value)
                                                }
                                                errorText={
                                                    !!sipDetails && !!currentScheme.frequency
                                                        ? showHintTemplateForMaxAndMin({
                                                              min:
                                                                  sipDetails[
                                                                      currentScheme.frequency
                                                                  ]?.minimumInstallments[
                                                                      calculateInstallment(
                                                                          installment_diff,
                                                                          sipDetails,
                                                                          currentScheme,
                                                                      )
                                                                  ].minAmount || 1,
                                                              max:
                                                                  sipDetails[
                                                                      currentScheme.frequency
                                                                  ]?.minimumInstallments[
                                                                      calculateInstallment(
                                                                          installment_diff,
                                                                          sipDetails,
                                                                          currentScheme,
                                                                      )
                                                                  ].maxAmount ||
                                                                  DEFAULT_MAX_INVESTMENT,
                                                              multiples:
                                                                  sipDetails[
                                                                      currentScheme.frequency
                                                                  ]?.multiples || 1,
                                                          })
                                                        : ''
                                                }
                                                handleError={setErrors}
                                                handleTouch={setTouched}
                                                touched={touched}
                                            />
                                        </AsyncLoader>
                                    </div>
                                    <div className="investment-amount-select">
                                        <FormControl
                                            variant="filled"
                                            className="mf-investment-select"
                                        >
                                            <AsyncLoader
                                                skelton={
                                                    <TabElementSkeleton width={120} height={35} />
                                                }
                                                data={rtaSchemeCalled}
                                            >
                                                <p>
                                                    {dbCommercial.exploreMfs.mfInvestment.frequency}
                                                </p>
                                            </AsyncLoader>
                                            <AsyncLoader
                                                skelton={
                                                    <TabElementSkeletonRect
                                                        width={250}
                                                        height={50}
                                                    />
                                                }
                                                data={rtaSchemeCalled}
                                            >
                                                <Select
                                                    labelId="frequency-label"
                                                    id="frequency"
                                                    value={currentScheme.frequency || 'Monthly'}
                                                    onChange={(e: any) => {
                                                        setScheme({
                                                            ...currentScheme,
                                                            frequency: e.target.value,
                                                        });
                                                        setErrors((prev: any) => ({
                                                            ...prev,
                                                            amount: false,
                                                        }));
                                                    }}
                                                >
                                                    {Object.keys(
                                                        !!sipDetails ? sipDetails : {},
                                                    ).map((option: string) => (
                                                        <MenuItem value={option}>{option}</MenuItem>
                                                    ))}
                                                </Select>
                                            </AsyncLoader>
                                        </FormControl>
                                        <FormControl
                                            variant="filled"
                                            className="mf-investment-select"
                                        >
                                            <AsyncLoader
                                                skelton={
                                                    <TabElementSkeleton width={180} height={35} />
                                                }
                                                data={rtaSchemeCalled}
                                            >
                                                <p>
                                                    {
                                                        dbCommercial.exploreMfs.mfInvestment
                                                            .selectSipDay
                                                    }
                                                </p>
                                            </AsyncLoader>
                                            <AsyncLoader
                                                skelton={
                                                    <TabElementSkeletonRect
                                                        width={250}
                                                        height={50}
                                                    />
                                                }
                                                data={rtaSchemeCalled}
                                            >
                                                {kfinFlag &&
                                                (currentScheme.frequency === freqType.W ||
                                                    currentScheme.frequency === freqType.F) &&
                                                isWeekdayNamedArray(
                                                    !!sipDetails
                                                        ? sipDetails[
                                                              !!currentScheme.frequency
                                                                  ? currentScheme.frequency
                                                                  : 'Monthly'
                                                          ]?.dates || []
                                                        : [],
                                                ) ? (
                                                    getWeekdayDropdownOptions(
                                                        !!sipDetails
                                                            ? sipDetails[
                                                                  !!currentScheme.frequency
                                                                      ? currentScheme.frequency
                                                                      : 'Monthly'
                                                              ]?.dates || []
                                                            : [],
                                                    )?.length > 1 ? (
                                                        <Select
                                                            labelId="select-sip-label"
                                                            id="select-sip"
                                                            value={
                                                                selectedWeekday ||
                                                                getWeekdayDropdownOptions(
                                                                    !!sipDetails
                                                                        ? sipDetails[
                                                                              !!currentScheme.frequency
                                                                                  ? currentScheme.frequency
                                                                                  : 'Monthly'
                                                                          ]?.dates || []
                                                                        : [],
                                                                )[0]?.value ||
                                                                ''
                                                            }
                                                            onChange={(e: any) => {
                                                                setSelectedWeekday(
                                                                    e.target.value,
                                                                );
                                                            }}
                                                        >
                                                            {getWeekdayDropdownOptions(
                                                                !!sipDetails
                                                                    ? sipDetails[
                                                                          !!currentScheme.frequency
                                                                              ? currentScheme.frequency
                                                                              : 'Monthly'
                                                                      ]?.dates || []
                                                                    : [],
                                                            ).map(({ value, label }) => (
                                                                <MenuItem
                                                                    key={value}
                                                                    value={value}
                                                                >
                                                                    {label}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    ) : (
                                                        <TextField
                                                            variant="filled"
                                                            className="mf-investment-select"
                                                            hiddenLabel
                                                            value={formatWeekdayDisplay(
                                                                !!sipDetails
                                                                    ? sipDetails[
                                                                          !!currentScheme.frequency
                                                                              ? currentScheme.frequency
                                                                              : 'Monthly'
                                                                      ]?.dates || []
                                                                    : [],
                                                            )}
                                                            disabled
                                                        />
                                                    )
                                                ) : (
                                                    <Select
                                                        labelId="select-sip-label"
                                                        id="select-sip"
                                                        value={sipDay || new Date().getDate()}
                                                        onChange={(e: any) =>
                                                            setSipDay(e.target.value)
                                                        }
                                                    >
                                                        {isMotilalWeekly(
                                                            commonDetails?.amc,
                                                            currentScheme?.frequency,
                                                        )
                                                            ? MOTILAL_WEEKLY_DAYS.map(
                                                                  ({ value, label }) => (
                                                                      <MenuItem value={value}>
                                                                          {label}
                                                                      </MenuItem>
                                                                  ),
                                                              )
                                                            : getSipDays(
                                                                  !!sipDetails
                                                                      ? sipDetails[
                                                                            !!currentScheme.frequency
                                                                                ? currentScheme.frequency
                                                                                : 'Monthly'
                                                                        ]?.dates || []
                                                                      : [],
                                                              )?.map((val: number) => (
                                                                  <MenuItem value={val}>
                                                                      {val}
                                                                  </MenuItem>
                                                              ))}
                                                    </Select>
                                                )}
                                            </AsyncLoader>
                                        </FormControl>
                                    </div>
                                    <div className="sip-run-time">
                                        <AsyncLoader
                                            skelton={
                                                <TabElementSkeletonRect width={250} height={70} />
                                            }
                                            data={rtaSchemeCalled}
                                        >
                                            <DatePickerInput
                                                className="sip-date-input"
                                                label="Start Date"
                                                value={startDate}
                                                disableFuture={false}
                                                disablePast={true}
                                                maxDate={OTM_MAX_DATE(startDate)}
                                                onChange={(e) => {
                                                    setStartDate(e || new Date());
                                                }}
                                                helperText={`No. of Installments is ${installment_diff}`}
                                                shouldDisableDate={(day: MaterialUiPickersDate) => {
                                                    if (
                                                        isMotilalWeekly(
                                                            commonDetails?.amc,
                                                            currentScheme?.frequency,
                                                        )
                                                    ) {
                                                        return isMotilalSipStartDateDisabled(
                                                            day,
                                                            currentScheme?.frequency,
                                                            commonDetails?.amc,
                                                            sipDay,
                                                        );
                                                    }
                                                    return (
                                                        startDateDisable(
                                                            day,
                                                            sipDetails,
                                                            currentScheme,
                                                            startDate,
                                                            false,
                                                            kfinFlag,
                                                            selectedWeekday,
                                                        ) ||
                                                        isMotilalSipStartDateDisabled(
                                                            day,
                                                            currentScheme?.frequency,
                                                            commonDetails?.amc,
                                                        )
                                                    );
                                                }}
                                            />
                                        </AsyncLoader>
                                        <div className="mf-invest-perpetual">
                                            <AsyncLoader
                                                skelton={
                                                    <TabElementSkeletonRect
                                                        width={250}
                                                        height={70}
                                                    />
                                                }
                                                data={rtaSchemeCalled}
                                            >
                                                <DatePickerInput
                                                    className="sip-date-input"
                                                    disablePast={true}
                                                    label="End Date"
                                                    maxDate={OTM_MAX_DATE(startDate)}
                                                    value={endDate}
                                                    onChange={(e) => {
                                                        console.log(e, 'e');
                                                        setEndDate(e || new Date());
                                                    }}
                                                    disabled={perpetual}
                                                    disableFuture={false}
                                                    shouldDisableDate={(
                                                        day: Date | MaterialUiPickersDate,
                                                    ) => {
                                                        // For Motilal weekly only restrict to the
                                                        // start-date weekday (and weekends-out);
                                                        // any day-of-month is acceptable.
                                                        if (
                                                            isMotilalWeekly(
                                                                commonDetails?.amc,
                                                                currentScheme?.frequency,
                                                            )
                                                        ) {
                                                            return (
                                                                !!day &&
                                                                (day.getDay() === 0 ||
                                                                    day.getDay() === 6 ||
                                                                    day.getDay() !==
                                                                        startDate.getDay() ||
                                                                    day > OTM_MAX_DATE(startDate))
                                                            );
                                                        }
                                                        return (
                                                            endDateDisable(
                                                                day,
                                                                sipDetails,
                                                                currentScheme,
                                                                startDate,
                                                                endDate,
                                                                false,
                                                                kfinFlag,
                                                                selectedWeekday,
                                                            ) ||
                                                            isMotilalSipEndDateDisabled(
                                                                day,
                                                                startDate,
                                                                currentScheme?.frequency,
                                                                commonDetails?.amc,
                                                            ) ||
                                                            (!!day && day > OTM_MAX_DATE(startDate))
                                                        );
                                                    }}
                                                    error={!!errors.dateError}
                                                    helperText={`Minimum Installments is ${
                                                        !!sipDetails
                                                            ? sipDetails[
                                                                  currentScheme?.frequency || 0
                                                              ]?.minimumInstallments[
                                                                  calculateInstallment(
                                                                      installment_diff,
                                                                      sipDetails,
                                                                      currentScheme,
                                                                  )
                                                              ].installment || 1
                                                            : 1
                                                    }`}
                                                    views={
                                                        !!currentScheme.frequency
                                                            ? handleCalendarView(
                                                                  currentScheme.frequency as freqType,
                                                              )
                                                            : ['year', 'month', 'date']
                                                    }
                                                />
                                            </AsyncLoader>
                                            <AsyncLoader
                                                skelton={
                                                    <TabElementSkeleton width={110} height={35} />
                                                }
                                                data={rtaSchemeCalled}
                                            >
                                                <CheckBoxField
                                                    label="Perpetual(max 40 years)"
                                                    value={perpetual}
                                                    onChange={() => setPerpetual((prev) => !prev)}
                                                />
                                            </AsyncLoader>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className="mf-investment-amount" style={{ paddingBottom: 20 }}>
                                    <AsyncLoader
                                        skelton={<TabElementSkeleton width={110} height={30} />}
                                        data={rtaSchemeCalled}
                                    >
                                        <> {dbCommercial.exploreMfs.mfInvestment.sipAllow}</>
                                    </AsyncLoader>
                                </div>
                            )}
                        </div>
                        <div className="mf-investment-bottom">
                            <div className="disclaimers">
                                <FormControl>
                                    <AsyncLoader
                                        skelton={<TabElementSkeleton width={450} height={35} />}
                                        data={rtaSchemeCalled}
                                    >
                                        <FormControlLabel
                                            className="inline-checkbox"
                                            control={
                                                <Checkbox
                                                    name="terms-conditions"
                                                    onChange={() =>
                                                        setTermsAccept((prev) => ({
                                                            checked: !prev.checked,
                                                            message: prev.checked
                                                                ? dbCommercial.errors
                                                                      .termsAndCondition
                                                                : '',
                                                        }))
                                                    }
                                                    checked={termsAccept.checked}
                                                    disabled={!!loading}
                                                />
                                            }
                                            label={
                                                <>
                                                    {
                                                        dbCommercial.exploreMfs.mfInvestment
                                                            .disclaimers
                                                    }
                                                    <a onClick={() => setShow(!show)}>
                                                        {
                                                            dbCommercial.exploreMfs.mfInvestment
                                                                .termsLink
                                                        }
                                                    </a>
                                                    {dbCommercial.exploreMfs.mfInvestment.of}
                                                    <span>
                                                        {
                                                            dbCommercial.exploreMfs.mfInvestment
                                                                .mfCentral
                                                        }
                                                    </span>
                                                </>
                                            }
                                        />
                                    </AsyncLoader>
                                    {termsAccept.message && (
                                        <FormHelperText
                                            style={{
                                                color: 'red',
                                                fontSize: 14,
                                                textAlign: 'left',
                                            }}
                                        >
                                            {termsAccept.message}
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </div>

                            <div className="buttons">
                                <AsyncLoader
                                    skelton={<TabElementSkeletonRect width={250} height={50} />}
                                    data={rtaSchemeCalled}
                                >
                                    <>
                                        <SubmitButtonWithLoader
                                            className="customBtn "
                                            onClick={
                                                folioPurchaseType === folioPurchaseEnum.EXISTING
                                                    ? () => setCallPanSeed(true)
                                                    : () => setMatchPan(true)
                                            }
                                            loading={loading == 1}
                                            disabled={
                                                disableInvestment() ||
                                                consolidateErrors(errors) ||
                                                !latestDataCalled
                                            }
                                            labelWhileLoading={`Sending`}
                                            label={dbCommercial.exploreMfs.mfInvestment.invest}
                                        />
                                        {!!isNewToMF && (
                                            <SubmitButtonWithLoader
                                                className="customBtn "
                                                onClick={() => {
                                                    setMatchPan(true);
                                                    setInvestLaterClicked(true);
                                                }}
                                                loading={loading == 2}
                                                disabled={
                                                    disableInvestment() || consolidateErrors(errors)
                                                }
                                                labelWhileLoading={`Sending`}
                                                label={
                                                    dbCommercial.exploreMfs.mfInvestment.invest +
                                                    ' Later'
                                                }
                                            />
                                        )}
                                    </>
                                </AsyncLoader>
                            </div>
                        </div>
                        <FaqLink section={NEW_PURCHASE} />
                    </div>
                </div>
                {!!folios &&
                folios.length > 0 &&
                folioPurchaseType === folioPurchaseEnum.EXISTING ? (
                    AdditionalPurchaseDetails
                ) : (
                    <ProfileDetails />
                )}
            </div>
            <IFSCError open={ifscError} setOpen={setIfscError} />
            <Dialog
                onClose={() => props.history.replace(`${explorePath}`)}
                maxWidth={'sm'}
                open={activeHandle}
                aria-labelledby="transmission-main-modal"
            >
                <div className="note-modals transmission-main-modal">
                    <h3>{dbCommercial.exploreMfs.inactiveScheme}</h3>
                    <p>{dbCommercial.exploreMfs.inactiveSchemeInfo}</p>
                    <div className="note-modals-btns">
                        <Button
                            className="customBtn"
                            onClick={() => props.history.replace(`${explorePath}`)}
                        >
                            {dashboard.TransmissionRequest.holderDetails.modal.okay}
                        </Button>
                    </div>
                </div>
            </Dialog>
            <SwipeableDrawer
                anchor={'bottom'}
                open={openDrawer}
                onClose={() => setDrawer(false)}
                onOpen={() => setDrawer(true)}
                className="explore-mf-drawer profile-details-drawer"
            >
                <div className="filters-drawer-total">
                    <div className="filters-top">
                        <h5>
                            <img
                                src="/images/right-arrow-long-black.svg"
                                alt="icon"
                                onClick={() => setDrawer(false)}
                            />
                            {dbCommercial.exploreMfs.mfInvestment.profileDetails}
                        </h5>
                        <a onClick={handleEdit}>
                            <img src="/images/edit-purple.svg" alt="icon" />
                            Edit
                        </a>
                    </div>
                    <div className="filters-drawer-content">
                        <div className="profile-details-drawer">
                            <p className="info">
                                <img src="/images/exclaim.svg" alt="icon" />
                                {dbCommercial.exploreMfs.mfInvestment.prefilled}
                            </p>
                            <details open>
                                <summary>
                                    {dbCommercial.exploreMfs.mfInvestment.personalDetails}
                                    <img src="/images/down-arrow-grey.svg" alt="icon" />
                                </summary>
                                <div className="profile-details">
                                    <div className="profile-details-info">
                                        <div className="profile-details-txt">
                                            <p>{dbCommercial.exploreMfs.mfInvestment.name}</p>
                                            <h6>{purchaseDetails.investorName}</h6>
                                        </div>
                                        <div className="profile-details-txt">
                                            <p>{dbCommercial.exploreMfs.mfInvestment.panNo}</p>
                                            <h6>{pan}</h6>
                                        </div>
                                        <div className="profile-details-txt">
                                            <p>{dbCommercial.exploreMfs.mfInvestment.moh}</p>
                                            <h6>{purchaseDetails.modeOfHolding}</h6>
                                        </div>
                                    </div>
                                </div>
                            </details>
                            <details>
                                <summary>
                                    {dbCommercial.exploreMfs.mfInvestment.nomineeDetails}
                                    <img src="/images/down-arrow-grey.svg" alt="icon" />
                                </summary>
                                <div className="profile-details">
                                    {purchaseDetails.nominees.map((nominee: any, index: number) => {
                                        return (
                                            <div className="profile-details-info">
                                                <h2>{`Nominee ${index + 1}`}</h2>
                                                <div className="profile-details-txt">
                                                    <p>
                                                        {dbCommercial.exploreMfs.mfInvestment.name}
                                                    </p>
                                                    <h6>{nominee.name}</h6>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </details>
                            <details>
                                <summary>
                                    {dbCommercial.exploreMfs.mfInvestment.bankDetails}
                                    <img src="/images/down-arrow-grey.svg" alt="icon" />
                                </summary>
                                <div className="profile-details">
                                    <div className="profile-details-info">
                                        <h2>{purchaseDetails?.bank[0]?.name}</h2>
                                        <div className="profile-details-txt">
                                            <p>{dbCommercial.exploreMfs.mfInvestment.bank.ifsc}</p>
                                            <h6>{purchaseDetails?.bank[0]?.ifsc}</h6>
                                        </div>
                                        <div className="profile-details-txt">
                                            <p>{dbCommercial.exploreMfs.mfInvestment.panNo}</p>
                                            <h6>{props.pan}</h6>
                                        </div>
                                        <div className="profile-details-txt">
                                            <p>
                                                {
                                                    dbCommercial.exploreMfs.mfInvestment.bank
                                                        .accountNo
                                                }
                                            </p>
                                            <h6>{purchaseDetails?.bank[0]?.accountNo}</h6>
                                        </div>
                                    </div>
                                </div>
                            </details>
                            <details>
                                <summary>
                                    {dbCommercial.exploreMfs.mfInvestment.fatcaDetails}
                                    <img src="/images/down-arrow-grey.svg" alt="icon" />
                                </summary>
                                <div className="profile-details">
                                    <div className="profile-details-info">
                                        <div className="profile-details-txt">
                                            <p>{dbCommercial.exploreMfs.mfInvestment.fatca.cotr}</p>
                                            {!!countries && (
                                                <h6>
                                                    {getCountryNameFromCode(
                                                        countries,
                                                        taxResidency[0]?.countryTax,
                                                    )}
                                                </h6>
                                            )}
                                        </div>
                                        <div className="profile-details-txt">
                                            <p>{dbCommercial.exploreMfs.mfInvestment.fatca.tin}</p>
                                            <h6>{taxResidency[0]?.taxId}</h6>
                                        </div>
                                        <div className="profile-details-txt">
                                            <p>
                                                {
                                                    dbCommercial.exploreMfs.mfInvestment.fatca
                                                        .taxIdType
                                                }
                                            </p>
                                            <h6>{taxResidency[0]?.idType}</h6>
                                        </div>
                                    </div>
                                </div>
                            </details>
                        </div>
                    </div>
                </div>
            </SwipeableDrawer>
            <Dialog fullWidth maxWidth={'lg'} open={show} aria-labelledby="terms-modal">
                <div className="terms-modal">
                    <div className="heading">
                        <h2>{common.termsConditions}</h2>
                        <a className="close">
                            <img
                                onClick={() => setShow(!show)}
                                src="/images/close-white.svg"
                                alt="icon"
                            />
                        </a>
                    </div>
                    <div className="content-outer">
                        <div className="content-inner">
                            <p>{dbCommercial.termsModal.newPurchase.info1}</p>
                            <p>{dbCommercial.termsModal.newPurchase.info2}</p>
                            <p>{dbCommercial.termsModal.newPurchase.info3}</p>
                            <a
                                style={{ textDecoration: 'underline', color: '#836fe0' }}
                                onClick={() => {
                                    window.open(`/fixtures/payment_matrix.pdf`, '_system');
                                }}
                            >
                                {dbCommercial.termsModal.additionalPurchase.info4}
                            </a>
                        </div>
                    </div>
                </div>
            </Dialog>
            <NavDialog
                amc={schemeAMC || amcCode}
                showNavDialog={showNavDialog}
                setShowNavDialog={setShowNavDialog}
                handleInvest={handleInvest}
            />
            <Dialog fullWidth maxWidth={'lg'} open={euin} aria-labelledby="terms-modal">
                <div className="terms-modal">
                    <div className="heading">
                        <h2>{common.euinDeclaration}</h2>
                        <a className="close" onClick={() => setEuin(!euin)}>
                            <img src="/images/close-white.svg" alt="icon" />
                        </a>
                    </div>
                    <div className="content-outer">
                        <div className="content-inner">
                            <p>{dbCommercial.euinModal.info}</p>
                        </div>
                    </div>
                </div>
            </Dialog>
            {folioPurchaseType === folioPurchaseEnum.EXISTING && (
                <NomineePopup folio={currentFolio.toString()} />
            )}
            <RtaSchemeLoadingDialog open={!rtaSchemeCalled} />
        </div>
    );
}
export default connect(
    ({ authReducer, portfolio, newPurchase }: RootStateType) => ({
        ...authReducer,
        ...portfolio,
        ...newPurchase,
    }),
    {
        getCountries,
        getInvestorLatestDetails,
        getNewSchemeDetail,
        makeNewPurchase,
        getFundTransactionInfo,
        sendOtp: sendPhoneOTP,
        sendMobileOTP,
        sendEmailOTP,
        checkFatca,
        performPennyDropValidation,
    },
)(MfInvestment);

export const NIPPON_MAX_AMOUNT = 200000;
